import { gql } from '@apollo/client'
import React from 'react'

import { accountsClient } from '../../../../utils/apollo/api'
import { useModalData } from '../../../../components/modals/ModalsContext'
import { useQuery } from '../../../../utils/apollo/_helpers/useQuery'
import StatePresenter from '../../../../components/helpers/StatePresenter'

const Context = React.createContext([])
const { Provider } = Context
export const useUsersState = () => React.useContext(Context)
export const useUsers = () => useUsersState()?.users

const QUERY = gql`
  query Users($ids: [Integer]) {
    users(filter: { ids: $ids, includeDisabled: true, ignoreSegments: true }) {
      id
      name
      email
      insertedAt
      contract {
        id
        workShifts
        group {
          id
          name
        }
        groups {
          id
          name
        }
        profile {
          id
          name
          label
        }

        fieldValues {
          id
          value
          fieldId
          field {
            id
            type
            name
          }
        }
      }
    }
  }
`

const UsersLoader = ({ children }) => {
  const ids = useModalData()
  const { data, ...state } = useQuery(QUERY, {
    skip: !ids?.length,
    variables: { ids },
    client: accountsClient,
    fetchPolicy: 'no-cache'
  })

  return (
    <StatePresenter {...state}>
      <Provider value={data}>{children}</Provider>
    </StatePresenter>
  )
}

export default UsersLoader
